import { Page } from '@/components/layout/page/page.tsx'
import { VipSupport } from '@/modules/vip-support/ui/VipSupport.tsx'

export const VipSupportView = () => {
  return (
    <Page>
      <VipSupport />
    </Page>
  )
}
